import { ClipboardPaste } from 'lucide-react';
import { Button } from 'v5/design-system/Button';
import { Kbd } from 'v5/design-system/Kbd';
import { ModifierKey } from 'v5/primitives/ModifierKey';

/** Reads the clipboard; the shortcut beside it works while the field has focus. */
export function PasteButton({
  label,
  disabled,
  onClick
}: {
  label: string;
  disabled: boolean;
  onClick(): void;
}) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      disabled={disabled}
      onClick={onClick}
    >
      <ClipboardPaste className="size-4" />
      {label}
      <Kbd className="-mr-1 normal-case">
        <ModifierKey />V
      </Kbd>
    </Button>
  );
}
